
<template>
  <div id="contenedor">
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- Carga el compononte para activar modal de  ver calendario -->
    <component :is="componentCalendar" :datos="paramsClases" @closeCalendar="closeModalCalendar"></component>

    <!-- boton crear -->
    <v-row>
      <v-col cols="6">
        <AutocompleteComp text-label="Estudiante" :items="AlumnosFam" autocomplete="off" v-model="alumno"
          item-value="id_alumno" item-text="persona.nombre_completo" @change="getAllAreasFamilia(alumno)"
          return-object />
      </v-col>
      <v-col class="d-flex justify-end ">
        <v-tooltip right color="#1b1b1b">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" color="primary" class="animate__animated animate__pulse animate__infinite"
              @click="verFiltros = true">
              <v-icon small left>fas fa-filter</v-icon>
              Filtros
            </v-btn>
          </template>
          <span>Filtros avanzados </span>
        </v-tooltip>
        <ButtonComp @click="generarExcel" textButton="Ver horario" icon-but="fas fa-file" normal-button class="mx-2" />
        <ButtonComp @click="verCalendario" v-if="botonCalendario" text-button="Ver calendario" iconBut="fas fa-calendar"
          normal-button />
      </v-col>
    </v-row>
    <!-- fin de boton -->

    <!-- PANTALLA PRINCIPAL DE PROGRAMACION DOCENTE  -->
    <v-row>
      <v-col cols="12">

        <ComundataTablecomp :headers="ClasesdelEstudiante" :items="ClasesFamilia" :search="search" whitSearch>
          <template v-slot>
            <v-col cols="12" class="d-flex">
              <v-chip label class="mx-2">
                Nivel :
                <span>{{ NivelAlumno = "" ? 'Sin definir' : NivelAlumno }}</span>
              </v-chip>
              <v-chip label class="mx-2">
                Grado :
                <span>{{ GradoAlumno = "" ? 'Sin definir' : GradoAlumno }}</span>
              </v-chip>
              <v-chip label class="mx-2">
                Sección :
                <span> {{ SeccionAlumno= "" ? 'Sin definir' : SeccionAlumno }}</span>
              </v-chip>
            </v-col>


          </template>
          <template v-slot:desc_curso="{ item }">
            <v-chip :color="item.color_curso" small dark>
              <v-icon left small>
                {{ item.icono_curso }}
              </v-icon>
              {{ item.desc_curso }}
            </v-chip>
          </template>

          <template v-slot:fecha="{ item }">
            <span>{{ item.fecha | filtroFecha }}</span>
          </template>

          <template v-slot:horaIn="{ item }">
            <span>{{ item.hora_inicio | filtroFormatoHora }}</span>
          </template>

          <template v-slot:horaFin="{ item }">
            <span>{{ item.hora_fin | filtroFormatoHora }}</span>
          </template>

          <template v-slot:asistencia="{ item }">
            <v-chip v-if="item.estado_asistencia === null">Sin asistencia</v-chip>
            <v-chip :style="{ background: item.color_est_asistencia, color: '#fff' }" v-else>{{ item.estado_asistencia
            }}</v-chip>
          </template>

          <template v-slot:archivoAsistencia="{ item }">
            <v-chip v-if="item.archivo_asistencia === null">Sin archivo</v-chip>
            <v-chip class="primary" v-else>
              <a style="text-decoration: none; color: #fff"
                @click="download_file(URL_SPACE + '/' + item.ruta_asistencia)">{{
                  item.archivo_asistencia }}</a></v-chip>
          </template>
          <template v-slot:comentarioAsistencia="{ item }">
            <v-menu absolute offset-y style="max-width: 600px">
              <template v-slot:activator="{ on }">
                <v-row justify="space-around" v-on="on">
                  <span v-if="item.observacion_asistencia === null"><v-chip color="error">Sin comentario</v-chip></span>
                  <v-btn text v-else><v-icon color="primary">fa-comment-dots</v-icon></v-btn>
                </v-row>
              </template>
              <v-card max-width="250px" class="py-2 px-2">
                <v-tooltip bottom color="#1b1b1b">
                  <template v-slot:activator="{ on }">
                    {{ item.observacion_asistencia }}
                  </template>
                </v-tooltip>
              </v-card>
            </v-menu>
          </template>

          <template v-slot:estado="{ item }">
            <v-chip :style="{ background: item.color_estado, color: '#fff' }">{{
              item.desc_estado
            }}</v-chip>
          </template>
        </ComundataTablecomp>

      </v-col>


    </v-row>



    <v-row dense>
      <v-col cols="12">
        <v-chip label class="my-2 mx-2 primary">PRESENTE: {{ contPresente }}</v-chip>
        <v-chip label class="my-2 mx-2 info" dark>TARDANZA JUSTIFICADA: {{ contTardanzajust }}</v-chip>
        <v-chip label class="my-2 mx-2 warning">TARDANZA INJUSTIFICADA: {{ contTardanzainjus }}</v-chip>
        <v-chip label class="my-2 mx-2 deep-purple darken-1 " dark>FALTA JUSTIFICADA: {{
          contFaltajust
        }}</v-chip>
        <v-chip label class="my-2 mx-2 cyan darken-1" dark>FALTA INJUSTIFICADA: {{ contFaltainjus }}</v-chip>
        <v-chip label class="my-2 mx-2 success">TOTAL: {{ ClasesFamilia.length }}</v-chip>

      </v-col>
    </v-row>
    <!-- MODAL VISOR DE CONTENIDOS-->
    <v-dialog v-model="visor" scrollable max-width="80%">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row class="d-flex justify-space-between py-0">
            Contenido
            <v-btn fab dark x-small class="btn_style3" @click="cerrarVisor"><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="text-center">
          <component :is="tipoVisor" :diapositivas="api_list_contenidos"></component>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!---------------------->
    <!--  DRAWER FILTROS  -->
    <v-navigation-drawer width="350" app v-model="verFiltros" fixed temporary right>

      <v-toolbar dense dark color="primary">
        <v-icon small left> fas fa-search </v-icon> Filtros de busqueda
        <v-spacer></v-spacer>
        <v-tooltip left color="#1b1b1b">
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" icon color="yellow" @click="resetearFiltros()" class="mr-1">
              <v-icon>fa-sync-alt</v-icon>
            </v-btn>
          </template>
          <span>Restablecer filtros </span>
        </v-tooltip>
        <v-btn fab dark x-small class="btn_style3" @click="verFiltros = false">
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-toolbar>


      <v-list-item>
        <v-list-item-content>
          <v-container>
            <v-row>

              <v-col cols="12">
                <AutocompleteComp text-label="Área" :items="AreaFam" :isDisable="inhabilitarAreaFam" autocomplete="off"
                  item-value="id" item-text="desc_area" v-model="NivelA" @change="getAllClases(), getAllCursosFamilia(NivelA)"
                  return-object />
              </v-col>

              <v-col cols="12">
                <AutocompleteComp text-label="Curso" :items="CursoFam" :isDisable="inhabilitarCursoFam" autocomplete="off"
                  item-value="id_curso" item-text="desc_curso" v-model="paramsClases.id_curso"
                  @change="getAllClases('curso')" />

              </v-col>

              <v-col cols="12">
                <v-menu :disabled="inhabilitarCursoFam ? true : false" v-model="menuStartData"
                  :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template :disabled="true" v-slot:activator="{ on, attrs }">
                    <v-text-field dense v-model="paramsClases.fecha_inicio" label="Fecha inicial" readonly v-bind="attrs"
                      v-on="on" clearable @click:clear="paramsClases.fecha_inicio = ''; getAllClases()"></v-text-field>
                  </template>
                  <v-date-picker v-model="paramsClases.fecha_inicio"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
                    no-title scrollable @input="menuStartData = false; getAllClases()"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12">

                <v-menu :disabled="inhabilitarCursoFam ? true : false" v-model="menuEndData"
                  :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field dense v-model="paramsClases.fecha_fin" label="Fecha final" readonly v-bind="attrs"
                      v-on="on" clearable @click:clear="paramsClases.fecha_fin = ''; getAllClases()">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="paramsClases.fecha_fin"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
                    :min="paramsClases.fecha_inicio" no-title scrollable
                    @input="menuEndData = false; getAllClases()"></v-date-picker>
                </v-menu>
              </v-col>

            </v-row>
          </v-container>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import Calendario from "./components/calendarioClasesFamilia.vue";
import ModalVisorColegio from "./components/listaDiapositivas.vue";
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import { ClasesdelEstudiante } from "../../../helpers/headersTable";

export default {
  name: "clasesFamilia",
  components: {
    Calendario,
    ModalVisorColegio,
    ButtonComp,
    AutocompleteComp,
    ComundataTablecomp
  },

  data: () => ({
    paramComponente: { id_submodulo: 26, id_modulo: 7 },
    datoLogin: sessionStorage,
    test: false,
    ClasesdelEstudiante,
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },
    ruta_api: API_URL,
    URL_SPACE: BUCKET_ORIGIN_SPACE,
    inhabilitarNivelFam: true,
    inhabilitarGradoFam: true,
    inhabilitarAreaFam: true,
    inhabilitarCursoFam: true,
    inhabilitarSeccionFam: true,
    inhabilitarPeriodo: true,
    search: "",
    ///////////NUEVAS VARIABLES ////////////
    SeccionFam: [],
    AlumnosFam: [],
    AreaFam: [],
    CursoFam: [],
    NivelA: [],
    PeriodoFam: [],
    elrango: "",

    alumno: [],
    id_seccion: "",
    NivelAlumno: "",
    GradoAlumno: "",
    SeccionAlumno: "",

    ClasesFamilia: [],

    componentCalendar: "",
    modal_reporte: false,
    contPresente: 0,
    contTardanzajust: 0,
    contTardanzainjus: 0,
    contFaltajust: 0,
    contFaltainjus: 0,

    botonCalendario: false,
    botonReporte: false,

    paramsClases: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_alumno: null,
      id_area: null,
      id_curso: null,
      // fecha_inicio: null,
      // fecha_fin: null,
    },

    // modal asociar clase
    modal_asociarClase: false,
    formTitle: "",
    asociarCl: [], // asociar Clases
    search_asociarCl: "",
    //- ck1
    tablaCk1: true,
    clases: [],

    //- colegio
    tablaColegio: false,
    clasesColegio: [],

    nivelCont: [],
    id_nivelFiltro: "",

    gradoCont: [],
    id_gradoFiltro: [],

    gradoContFilter: [],

    areaCont: [],
    areaContFilter: [],
    id_areaFiltro: [],

    cursoCont: [],
    cursoContFilter: [],
    id_cursoFiltro: [],

    // modal visor de contenidos
    visor: false,
    api_list_contenidos: [],
    tipoVisor: "",
    menu2: false,

    menu3: false,

    //Componente de Filtros
    menuStartData: false,
    menuEndData: false,
    verFiltros: false,
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    nombre_clase() {
      return this.$route.params.value;
    },
    computedDateFormatted2() {
      return this.formatDate(this.programarCl.fecha);
    },
  },
  filters: {
    fechaTransform: function (string) {
      return string.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1");
    },
    //--------filtro para horas-----------------
    hora: function (hora) {
      var horaNew = parseInt(hora.substr(0, 2));
      var horaFormato = "";
      // si es pm
      if (horaNew >= 12) {
        if (horaNew == 12) {
          horaFormato = `${horaNew}:${hora.substr(3, 2)} PM`;
        } else if (horaNew > 12 && horaNew < 22) {
          horaFormato = `0${horaNew - 12}:${hora.substr(3, 2)} PM`;
        } else {
          horaFormato = `${horaNew - 12}:${hora.substr(3, 2)} PM`;
        }
      } else {
        if (horaNew == 0) {
          horaFormato = `12:${hora.substr(3, 2)} AM`;
        } else if (horaNew >= 1 && horaNew < 10) {
          horaFormato = `0${horaNew}:${hora.substr(3, 2)} AM`;
        } else {
          horaFormato = `${horaNew}:${hora.substr(3, 2)} AM`;
        }
      }
      if (!horaFormato) return null;
      //const [year, month, day] = date.split('-')
      return horaFormato;
    },
  },
  mounted() {
    this.loadMain()
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    //// modal calendario
    ...mapMutations("progDocente", ["setActivarCalendario"]),
    /** 
     ___________________________________________
    |          MÉTODO CARGA INICIAL          */
    loadMain() {

      this.getAllAlumnosFamilia();
      this.initValueRouter();

    },
    /** 
     _____________________________________________________________________________________
    |          MÉTODO REFERENCIADO CON VUEX PARA OBTENER PARAMETROS DE ROUTING          */
    async initValueRouter() {
      //LOGICA SIMULADOR CON CLASE
      if (!this.nombre_clase) {
        return false;
      }

      this.visualizarClase(this.nombre_clase);
    },
    /** 
     _______________________________________________________
    |          MÉTODO REFERENCIA INPUT TIPO FECHA         */
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    /** 
     ____________________________________________________
    |          MÉTODO GENERAR REPORTE DE EXCEL         */
    async generarExcel() {
      try {
        // this.generandoReporte = 1
        if (this.id_seccion == null || this.id_seccion == "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No tiene una sección asociada",
            tiempo: 3000,
          });
          // this.generandoReporte = 0
          return false;
        }
        this.setEnviarMens({
          tipo: "S",
          mensaje: "Generando reporte…",
          tiempo: 3000,
        });

        let data = {};
        let archivoADescargar = "";

        data = {
          anioLectivo: parseInt(this.datoLogin.id_ano_lectivo),
          seccion: parseInt(this.id_seccion),
          colegio: parseInt(this.datoLogin.id_colegio),
          codigoReporte: "horario_seccion",
          tamanioPorHoja: 50,
          BUCKET_ORIGIN_SPACE: BUCKET_ORIGIN_SPACE,
        };

        //generamos el reporte
        let response = await axios.post(
          "/reporte/formatoReporte/generarReporte",
          data
        );
        let dataResponse = response.data;
        this.setEnviarMens({
          tipo: dataResponse.messageT,
          mensaje: dataResponse.message,
          tiempo: 3000,
        });
        this.generandoReporte = 0;
        if (dataResponse.messageT == "S") {
          archivoADescargar = dataResponse.fileToDownload;
          axios({
            url:
              "/reporte/formatoReporte/bajarReporte/" + dataResponse.nameReport,
            method: "GET",
            responseType: "blob", // important
          }).then((response) => {
            this.setEnviarMens({
              tipo: "S",
              mensaje: "¡Descargando reporte!",
              tiempo: 3000,
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", archivoADescargar);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          });
        }
      } catch (e) {
        // this.generandoReporte = 0
        console.log(e);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "No se pudo generar el reporte. Por favor, vuelva a intentarlo.",
          tiempo: 3000,
        });
      }
    },
    /** 
     __________________________________________
    |          MÉTODO VER CALENDARIO         */
    verCalendario() {
      this.setActivarCalendario({ periodo: "", id_docente: "" });
      this.componentCalendar = "Calendario";
    },
    /** 
     ___________________________________________________________
    |          MÉTODO PARA CERRAR MODAL DE CALENDARIO         */
    closeModalCalendar() {
      this.componentCalendar = "";
    },
    /** 
     _____________________________________________________
    |          MÉTODO CARGAR HIJOS DE FAMILIAR          */
    async getAllAlumnosFamilia() {
      //this.$Files.dowload()
      try {
        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_persona: sessionStorage.id_persona,
          id_anio_lectivo: sessionStorage.id_ano_lectivo,
        };
        const response = await axios.post("/academico/padre/all/alu/", params);
        this.AlumnosFam = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     ___________________________________________________
    |          MÉTODO LISTAR AREAS DEL ALUMNO         */
    async getAllAreasFamilia(alumno) {
      this.paramsClases.id_alumno = alumno.id_alumno;
      this.NivelAlumno = alumno.desc_nivel;
      this.GradoAlumno = alumno.desc_grado;
      this.SeccionAlumno = alumno.nombre_seccion;
      this.id_seccion = alumno.id_seccion;

      try {
        const response = await axios.post(
          "/academico/padre/all/alu/ars/",
          this.paramsClases
        );
        this.AreaFam = response.data;
        this.inhabilitarAreaFam = false;
        this.getAllClases();
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     ________________________________________________
    |          MÉTODO LISTAR CURSOS ALUMNO         */
    async getAllCursosFamilia(nivel) {
      this.paramsClases.id_area = nivel.id;
      this.elrango = "";
      this.paramsClases.fecha_inicio = null;
      this.paramsClases.fecha_fin = null;
      this.CursoFam = [];
      try {
        const response = await axios.post(
          "/academico/padre//all/alu/curs/",
          this.paramsClases
        );
        this.CursoFam = response.data;
        this.inhabilitarCursoFam = false;
        this.getAllPeriodoFamilia(nivel.id_nivel);
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     _____________________________________________________________
    |          MÉTODO CARGAR TODAS LAS CLASES DE ALUMNOS        */
    async getAllClases() {

      try {
        const response = await axios.post(
          "/academico/padre/all/alu/class/",
          this.paramsClases
        );

        this.ClasesFamilia = response.data;

        if (this.ClasesFamilia.length > 0) {
          this.botonCalendario = true;
          this.botonReporte = true;
        } else {
          this.botonCalendario = false;
          this.botonReporte = false;
        }
        this.reporte(this.ClasesFamilia);

      } catch (error) {
        console.log(error);
      }
    },
    /** 
     _______________________________________________________________
    |          MÉTODO VISUALIZAR CLASES DE LA PROGRAMACION        */
    async visualizarClase(id_clase) {
      try {
        let response = await axios.get(
          "/administrativo/contenido/list/" + id_clase + ""
        );

        //let response = await axios.get("/administrativo/contenido/"+id_clase+"");
        this.api_list_contenidos = response.data;

        this.tipoVisor = "ModalVisorColegio";
        this.visor = true;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },
    /** 
     _______________________________________
    |          MÉTODO DE REPORTES         */
    reporte(item) {
      var pre = 0;
      var tardaJ = 0;
      var tardaI = 0;
      var faltaJ = 0;
      var faltaI = 0;
      for (var i = 0; i < item.length; i++) {
        switch (item[i].id_estado_asistencia) {
          case 1:
            pre = pre + 1;
            break;
          case 2:
            tardaJ = tardaJ + 1;
            break;
          case 3:
            tardaI = tardaI + 1;
            break;
          case 4:
            faltaJ = faltaJ + 1;
            break;
          case 5:
            faltaI = faltaI + 1;
            break;
          default:
            break;
        }
      }
      this.contPresente = pre;
      this.contTardanzajust = tardaJ;
      this.contTardanzainjus = tardaI;
      this.contFaltajust = faltaJ;
      this.contFaltainjus = faltaI;
    },
    /** 
     __________________________________________________
    |          MÉTODO CERRAR REPORTE MODAL          */
    closeModalReporte() {
      this.modal_reporte = false;
      this.contSinejecutar = 0;
      this.contEjecutada = 0;
      this.contProgramada = 0;
      this.contReprogramada = 0;
      this.contActualizada = 0;
    },
    /** 
     _________________________________________________
    |          MÉTODO CARGAR LOS PERDIODOS          */
    async getAllPeriodoFamilia(id_nivel) {
      try {
        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_nivel: id_nivel,
        };
        const response = await axios.post(
          "/academico/coordinador/act/alu/pdo/",
          params
        );
        this.PeriodoFam = response.data;
        this.inhabilitarPeriodo = false;
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     ___________________________________________________
    |          MÉTODO VER SEGUIMIENTO ALUMNO          */
    async verSeguimiento(id) {
      this.modal_seguimiento = true;

      let response = await axios.get(
        "/academico/progDocente/getSeguimiento/" + id
      );
      this.seguimientoClase = response.data.payload.Seguimiento;
    },
    /** 
     _________________________________________
    |          MÉTODO CERRAR MODAL          */
    cerrarVisor() {
      this.visor = false;
      this.api_list_contenidos = [];
      this.tipoVisor = "";
      //this.setCloseVisor()
    },
    /** 
     ______________________________________________
    |          MÉTODO DESCARGAR ARCHIVO          */
    async download_file(url) {
      await this.$Files['downloadFetch']({ url });
    },
    /** 
     ____________________________________________
    |          MÉTODO RESETEAR FILTROS         */
    resetearFiltros() {
      this.ClasesFamilia = [];
      this.alumno = [];
      this.NivelA = [];
      this.paramsClases = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_alumno: null,
        id_area: null,
        id_curso: null,
        fecha_inicio: null,
        fecha_fin: null,
      },
        this.inhabilitarNivelFam = true,
        this.inhabilitarGradoFam = true,
        this.inhabilitarAreaFam = true,
        this.inhabilitarCursoFam = true,
        this.inhabilitarSeccionFam = true,
        this.inhabilitarPeriodo = true,
        this.loadMain(false);
    },
  },
};
</script>
<style scoped>
.barra {
  height: 300px;
  position: relative;
  width: 100%;
  justify-content: center;
  align-content: center;
  display: flex;
  margin-top: 25px;
}

.programada {
  background: #6d6d6d;
  width: 20%;
  bottom: 0px;
  position: absolute;
  left: 0;
}

.ejecutada {
  background: #6abf69;
  width: 20%;
  bottom: 0px;
  position: absolute;
  left: 20%;
}

.sin-ejecutar {
  background: #e53935;
  width: 20%;
  bottom: 0px;
  position: absolute;
}

.reprogramada {
  background: #ffbc00;
  width: 20%;
  bottom: 0px;
  position: absolute;
  left: 60%;
}

.actualizada {
  background: #ffbc00;
  width: 20%;
  bottom: 0px;
  position: absolute;
  right: 0;
}

.programada h2 {
  position: absolute;
  left: 33%;
  font-size: 20px;
  bottom: 8px;
}

.ejecutada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
  text-align: center;
}

.sin-ejecutar h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}

.reprogramada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}

.actualizada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}

#programada {
  position: absolute;
  left: 5%;
  font-size: 16px;
  color: #6d6d6d;
  bottom: 14%;
}

#ejecutada {
  position: absolute;
  color: #6abf69;
  font-size: 16px;
  left: 26%;
  bottom: 14%;
}

#reprogramada {
  font-size: 16px;
  position: absolute;
  color: #ffbc00;
  left: 62%;
  bottom: 14%;
}

#sin-ejecutar {
  position: absolute;
  font-size: 15px;
  bottom: 14%;
  left: 45%;
  color: #e53935;
}

#actualizada {
  position: absolute;
  right: 7%;
  color: #ffbc00;
  bottom: 14%;
  font-size: 15px;
}

.nivel,
.grado,
.seccion {
  width: 100%;
  height: 50px;
  position: relative;
  border-bottom: 1px solid #1565c0;
}

.nivel span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.seccion span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.grado span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.nivel p {
  font-size: 13px;
}

.grado p {
  font-size: 13px;
}

.seccion p {
  font-size: 13px;
}

@media (max-width: 425px) {
  .seccion {
    margin-bottom: 10px;
  }
}

#contenedor {
  margin-bottom: 100px;
}

.card-alumnos {
  width: 100%;
  height: auto;
  background: #fff;
  border: 1px solid #b7babb;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0px 2px 9px 3px #b7babb;
  padding-bottom: 5px;
}

.title-alumnos {
  width: 100%;
  height: 20px;
  background: #0c67b8;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.alumno {
  width: 100%;
  padding-top: 9px;
  padding-left: 8px;
}

.title-alumnos h5 {
  color: #fff;
  text-transform: uppercase;
  text-align: center;
}

.sin-alumnos {
  width: 100%;
  height: 30px;
  background: #facc1e;
  text-align: center;
  margin-top: 5px;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
}
</style>
